import $ from 'jquery'
import _ from 'lodash'
import Chart from 'chart.js'

var colors = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  grey: 'rgb(201, 203, 207)',
}

var allColors = [
  colors.blue, colors.red, colors.orange, colors.yellow, colors.green,
  colors.blue, colors.red, colors.orange, colors.yellow, colors.green,
  colors.blue, colors.red, colors.orange, colors.yellow, colors.green,
  colors.blue, colors.red, colors.orange, colors.yellow, colors.green,
  colors.blue, colors.red, colors.orange, colors.yellow, colors.green,
  colors.blue, colors.red, colors.orange, colors.yellow, colors.green,
]

var createOptions = function (D, type, labels, data) {
  var opts = {
    data: {
      datasets: [{
        backgroundColor: allColors,
      },
      ],
    },
    options: {
      responsive: true,
      legend: { display: false, },
      title: { display: false, },
      tooltips: {
        enabled: false,
        custom: function (tooltip) {
          var tt = $('.chartjs-tooltip', D.element)
          if (tooltip.opacity === 0) {
            tt.css('opacity', 0)
            return
          }

          var e = tooltip.dataPoints[0].index
          tt.text(D.element.data('tooltip')[e])

          tt.css('opacity', 1)
          tt.css('left', this._chart.canvas.offsetLeft + tooltip.caretX + 'px')
          tt.css('top', this._chart.canvas.offsetTop + tooltip.caretY + 'px')
        },
      },
    },
  }

  opts.type = type
  opts.data.labels = labels
  opts.data.datasets[0].data = data
  if (type == 'bar') {
    opts.options.scales = {
      yAxes: [{
        ticks: {
          min: 0,
          max: _.max(data) + 2,
        },
      },
      ],
    }
  }
  if (type == 'line') {
    opts.data.datasets[0].pointRadius = 5
    opts.data.datasets[0].pointHoverRadius = 10
    opts.data.datasets[0].showLine = false
    opts.options.cutoutPercentage = 40
    opts.options.scales = {
      yAxes: [{
        ticks: {
          min: 0,
          padding: 15,
        },
      },
      ],
    }
  }
  if (type == 'pie') {
    opts.options.legend.display = true
  }
  return opts
}

function create(element, type, clickFunction) {
  console.log('chart:create', element, type)
  var D = {
    element: element,
    type: type,
    click: clickFunction,
  }

  D.element.empty()
  D.element.append('<canvas></canvas><div class="chartjs-tooltip">')
  D.chart = new Chart(
    $('canvas', D.element).get(0).getContext('2d'),
    createOptions(D, D.type, D.element.data('label'), D.element.data('value')))
  $('canvas', D.element).click(function (evt) {
    var points = D.chart.getElementsAtEventForMode(evt, 'point', D.chart.options)
    if (points.length == 0) { return }
    console.log('chart:click ' + points[0]._index)
    D.click && D.click(points[0]._index, D.element)
  })
}

var chart = {
  histogram: function (e, clickFunction) { create(e, 'bar', clickFunction) },
  pie: function (e, clickFunction) { create(e, 'pie', clickFunction) },
  points: function (e, clickFunction) { create(e, 'line', clickFunction) },
}

export { chart as default }
